// Approval chains — query-key factory (the stale-after-save gate keeps every
// queryKey literal in a *Keys file). Every chain read lives under the
// ["approval-chain"] prefix, so one prefix invalidation refreshes the item's
// chain, its preflight and the deal's endorsement records together.

import type { QueryClient } from "@tanstack/react-query";
import { collectionPackagesKeys } from "./collectionPackagesKeys";
import { collectionStagingKeys } from "@/api/collectionStagingKeys";

export const approvalChainKeys = {
  all: ["approval-chain"] as const,
  item: (itemId: string) => ["approval-chain", "item", itemId] as const,
  preflight: (packageId: string, itemId: string) =>
    ["approval-chain", "preflight", packageId, itemId] as const,
  endorsementRecords: (ownerEntityType: string, ownerEntityId: string) =>
    ["approval-chain", "endorsement-records", ownerEntityType, ownerEntityId] as const,
  loanGuarantors: (dealId: string) => ["approval-chain", "loan-guarantors", dealId] as const,
  buyerAccounts: (q: string) => ["approval-chain", "buyer-accounts", q] as const,
  /** The item's template, read by "Revise and restart" for its sender-field
   *  schema. Same shape as the template editor's read so the cache is shared. */
  template: (templateId: string) => ["collection-template", templateId] as const,
};

/** Every read a chain mutation changes: the chain family (item, preflight,
 *  endorsement records), the package detail (its items carry the chain status
 *  line) and the staging queue (a completed chain stages its signed PDF). */
export function invalidateApprovalChainReads(qc: QueryClient) {
  void qc.invalidateQueries({ queryKey: approvalChainKeys.all });
  void qc.invalidateQueries({ queryKey: collectionPackagesKeys.packageDetailPrefix });
  void qc.invalidateQueries({ queryKey: collectionStagingKeys.all });
}
